import {
  createContext,
  ReactNode,
  useCallback,
  useContext,
  useEffect,
} from 'react';

import {useParentRedirectionTrackers} from '@/app/main/authentication/pages/ParentRedirection/trackers';
import {AmplifyService, PlatformType} from '@/services';

type ViewModelContextType = {
  handleClickBack: () => void;
  handleClickPlatform: (platform: PlatformType) => void;
};

const ViewModelContext = createContext<ViewModelContextType | undefined>(
  undefined,
);

export function ViewModelProvider({children}: {children: ReactNode}) {
  const {clearData} = AmplifyService();
  const {trackViewParentRedirection, trackSelectDownloadApp} =
    useParentRedirectionTrackers();

  //#region [---- [HOOKS] ----]
  useEffect(() => {
    trackViewParentRedirection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  //#endregion

  const handleClickBack = useCallback(async () => {
    clearData();
  }, [clearData]);

  const handleClickPlatform = useCallback(
    (platform: PlatformType) => {
      trackSelectDownloadApp(platform);
    },
    [trackSelectDownloadApp],
  );

  return (
    <ViewModelContext.Provider
      value={{
        handleClickBack,
        handleClickPlatform,
      }}>
      {children}
    </ViewModelContext.Provider>
  );
}

export function useViewModelProvider() {
  const context = useContext(ViewModelContext);
  if (context === undefined) {
    throw new Error('ParentRedirection ViewModelContext is undefined');
  }
  return context;
}
